export const menuList = {
    "LESSONS": "Dersler",
    "CODELAB": "Codelab",
    "CODEMINO": "Codemino",
    "CODEBOO": "Codeboo",
    "CODECIZZ": "CodeÇizz",
    // "TEACHER_PRACTICES": "Eğitmen Alıştırmaları"
  }